const SET_LOGIN = 'SET_LOGIN';

const actions = {
  setLogin({ commit }, loginPermissions) {
    commit(SET_LOGIN, loginPermissions);
  },
};

const mutations = {
  [SET_LOGIN](state, loginPermissions) {
    state.login = loginPermissions;
  },
};

export default {
  namespaced: true,
  state: {
    login: [],
  },
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/permissions.js